import React from 'react';
import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  image?: string;
  url?: string;
  type?: string;
  noindex?: boolean;
}

const SEO: React.FC<SEOProps> = ({
  title = 'Daily Stories - European Erotic Tales',
  description = 'Sophisticated erotic stories set in Europe\'s most romantic cities. New intimate tales published daily. LGBTQ+ friendly. 18+ only.',
  keywords = 'erotic stories, adult fiction, lgbtq stories, european stories, intimate tales, sensual fiction, daily stories',
  image = 'https://dailystories.fr/podcast.png',
  url = 'https://dailystories.fr',
  type = 'website',
  noindex = false,
}) => {
  const fullTitle = title.includes('Daily Stories') ? title : `${title} | Daily Stories`;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      
      {/* Adult Content Rating */}
      <meta name="rating" content="adult" />
      <meta name="RATING" content="RTA-5042-1996-1400-1577-RTA" />
      
      {/* Robots */}
      {noindex ? <meta name="robots" content="noindex, nofollow" /> : <meta name="robots" content="index, follow" />}
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="512" />
      <meta property="og:image:height" content="512" />
      <meta property="og:image:alt" content={fullTitle} />
      <meta property="og:site_name" content="Daily Stories" />
      <meta property="og:locale" content="en_US" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:image:alt" content={fullTitle} />
      
      {/* Additional Meta */}
      <meta name="author" content="Daily Stories" />
      <meta name="language" content="English" />
      <link rel="canonical" href={url} />
    </Helmet>
  );
};

export default SEO;
